<template>
  <v-app>
    <v-app-bar app color="#F5A500" dark dense height="40px" justify-space-around>
      <div>
        <v-btn text :to="{ name: 'Dashboard' }" color="primary" outlined class="logo">
          <v-avatar size="36" class="mr-2">
            <img :src="require('@/assets/img/icons/logo.png')" alt="logo">
          </v-avatar>
          <span class="logo-text">{{ $t('app.name') }}</span>
        </v-btn>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        icon 
        @click.stop="info = true"
      >
        <v-icon>info</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main style="padding-bottom: 56px">
      <router-view></router-view>
    </v-main>

    <div v-if="adtag">
      <Adsense
        data-ad-client="ca-pub-4519316142120062"
        data-ad-slot="2249556605"
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></Adsense>
    </div>
    <v-bottom-navigation
      :fixed="true"
      justify="space-around"
      align="center"
      height="72px"
    >
      <v-btn  value="calendar" :to="{ name: 'Dashboard' }">
        <span :class="current() === 'Dashboard' ? 'current' : ''">{{ $t('bottom.calendar') }}</span>
        <v-icon :class="current() === 'Dashboard' ? 'current' : ''">mdi-calendar</v-icon>
      </v-btn>
      <v-btn value="history" :to="{ name: 'History' }">
        <span :class="current() === 'history' ? 'current' : ''">{{ $t('bottom.history') }}</span>
        <v-icon :class="current() === 'History' ? 'current' : ''">history</v-icon>
      </v-btn>
      <v-btn value="allergies" :to="{ name: 'Allergy' }">
        <span :class="current() === 'Allergy' ? 'current' : ''">{{ $t('bottom.allergies') }}</span>
        <v-icon :class="current() === 'Allergy' ? 'current' : ''">warning</v-icon>
      </v-btn>
      <v-btn value="config" :to="{ name: 'Config' }">
        <span :class="current() === 'Config' ? 'current' : ''">{{ $t('bottom.config') }}</span>
        <v-icon :class="current() === 'Config' ? 'current' : ''">settings</v-icon>
      </v-btn>
    </v-bottom-navigation>

    <v-dialog
      v-model="info"
      max-width="100%"
    >
      <v-card>
        <v-card-title class="headline">{{ $t('app.name') }}</v-card-title>
        <v-card outlined>
          <Information/>
        </v-card>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn outlined color="success" @click="toConfig">
                <v-icon>settings</v-icon>
                {{ $t('link.config') }}
              </v-btn>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn
                color="info"
                btn
                outlined
                @click="reload"
              >
                {{ $t('label.reload') }}
              </v-btn>
            </v-col>
            <v-col cols="12" class="text-center">
              <v-btn
                color="secondary"
                btn
                outlined
                @click="info = false"
              >
                {{ $t('label.close') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Information from "@/components/Information"

export default {
  name: "App",
  data: () => ({
    info: false,
    babyName: null,
    ageMonth: '',
    adtag: false
  }),
  components: {
    Information
  },
  mounted () {
    const version = this.$storage.getVersion()
    if (version === null || version < this.$version) {
      this.$storage.setVersion(this.$version)
    }
    if (process.env.NODE_ENV === 'production') {
      this.adtag = true
    }
  },
  methods: {
    current () {
      return this.$route.name;
    },
    toConfig () {
      if (this.current() !== 'Config') {
        this.$router.push({ name: 'Config' })
      }
      this.info = false
    },
    reload () {
      window.location.reload(true)
      this.info = false
    }
  }
};
</script>

<style>
@import "./assets/css/app.css";
</style>